import { Component, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { PeopleService } from 'src/app/services/people.service';

@Component({
  selector: 'ness-find-person',
  templateUrl: './find-person.component.html'
})
export class FindPersonComponent implements OnDestroy {
  @Input() excludePersons: ServerModels.ENESS_PersonDTO[];

  findPersonForm: FormGroup = this.fb.group({
    FilterID: ['', Validators.required],
    FilterInput: '',
    FilterDate: new FormControl<Date>(null),
    FilterSSN: '',
    FilterFirstNameInput: '',
    FilterLastNameInput: '',
    FilterPhoneNumber: ''
  });
  private _unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private fb: FormBuilder,
    public peopleService: PeopleService) { }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  public findMatchingPeople(): void {
    this.peopleService.findPeopleResultSubj.next([]);
    if (this.findPersonForm.valid) {
      let filterType: string = this.findPersonForm.get('FilterID').value;
      let filterValue: string = this.lookupFilterValue(filterType);
      if (!!filterValue) {
        let selectedFilterValues: ServerModels.FilterValues = {
          FilterColumnName: filterType,
          FilterValue: filterValue
        } as ServerModels.FilterValues;

        this.peopleService.findPeople([selectedFilterValues]).pipe(takeUntil(this._unsubscribe$)).subscribe({
          next: (matches: ServerModels.ENESS_PersonDTO[]) => {
            let matchesNotInUse = matches.filter(p => !this.excludePersons.some(e => p.PersonID == e.PersonID));
            this.peopleService.findPeopleResultSubj.next(matchesNotInUse);
          },
          error: (err:any) => console.log(err),
          complete: () => {
            this.findPersonForm.reset({
              FilterID: ''
            });
          }
        });
      }
    }
  }

  private lookupFilterValue(filterColumn: string): string {
    let filterColumnValue: string = null;
    switch (filterColumn) {
      case 'DateOfBirth':
        filterColumnValue = this.findPersonForm.get('FilterDate').value;
        break;
      case 'SSN':
        filterColumnValue = this.findPersonForm.get('FilterSSN').value.trim().replace(/_/g, '');
        break;
      case 'PhoneNumber':
        let phone: string = this.findPersonForm.get('FilterPhoneNumber').value;
        if (!!phone) {
          phone = phone.trim().replace(/\D/g, ''); // keep only digits
          if (phone.length > 3) {
            filterColumnValue = phone;
          }
        }       
        break;
      case 'Name':
        let firstName: string = this.findPersonForm.get('FilterFirstNameInput').value;
        let lastName: string = this.findPersonForm.get('FilterLastNameInput').value;
        if (!!firstName && !!lastName) {
          filterColumnValue = `${firstName.trim()} ${lastName.trim()}`;
        }
        else if (!!firstName) {
          filterColumnValue = `FirstName:${firstName.trim()}`;
        }
        else if (!!lastName) {
          filterColumnValue = `LastName:${lastName.trim()}`;
        }
        break;
      default:
        filterColumnValue = this.findPersonForm.get('FilterInput').value.trim();
    }

    return filterColumnValue;
  }
}
